import {
    EMAIL_CHANGED,
    PASSWORD_CHANGED,
    ERROR_MESSAGE_CHANGED,
    LOGIN_STATE_CHANGED,
    STATE_DEFAULT,
    CODE_CHANGED,
    CODE_REQUESTED_CHANGED
} from "../actions/loginActions";

const initialState = {
    email: "",
    password: "",
    errorMessage: "",
    loginState: STATE_DEFAULT,
    code: "",
    codeRequested: null
};

export default function login(state = initialState, action) {
    switch (action.type) {
        case EMAIL_CHANGED:
            return {
                ...state,
                email: action.payload
            };
        case PASSWORD_CHANGED:
            return {
                ...state,
                password: action.payload
            };
        case ERROR_MESSAGE_CHANGED:
            return {
                ...state,
                errorMessage: action.payload
            };
        case LOGIN_STATE_CHANGED:
            return {
                ...state,
                loginState: action.payload
            };
        case CODE_CHANGED:
            return {
                ...state,
                code: action.payload
            };
        case CODE_REQUESTED_CHANGED:
            return {
                ...state,
                codeRequested: action.payload
            }
        default:
            return state;
    }
}
